import { Star, StarBorder } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';

import { optionItemStyles } from '@/components/Selector/styles';
import { useYaMetrika } from '@/entities/yaMetrika';
import { AnalyticsEvent } from '@/types/yametrika';
import { YandexUser } from '@/types/yandex';

import s from './UserOptionItem.module.scss';

type UserOptionItemProps = {
  option: YandexUser;
  currentUserId?: string;
  isFavorite: (uid: string) => boolean;
  onFavoriteClick: (user: YandexUser) => void;
  props: React.HTMLAttributes<HTMLLIElement>;
  showFavoriteButton?: boolean;
};

export const UserOptionItem: React.FC<UserOptionItemProps> = observer(
  ({ option, currentUserId, isFavorite, onFavoriteClick, props, showFavoriteButton = true }) => {
    const isUserFavorite = isFavorite(option.uid);
    const { sendEvent } = useYaMetrika();

    const handleFavoriteClick = (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();

      if (!isUserFavorite) {
        sendEvent(AnalyticsEvent.addUserToFavorites);
      }

      onFavoriteClick(option);
    };

    return (
      <li
        {...props}
        key={option.uid}
        className={s.optionItem}
        style={{
          ...props.style,
          ...optionItemStyles,
          margin: '4px 8px',
        }}
      >
        <div className={s.option}>
          <div className={s.option_content}>
            <p className={s.option_label}>
              {option.display}
              {option.uid === currentUserId && <span> (я)</span>}
            </p>
            {option.email && <p className={s.option_description}>{option.email}</p>}
          </div>
          {showFavoriteButton && (
            <IconButton
              size="small"
              onClick={handleFavoriteClick}
              className={s.favoriteButton}
              sx={{
                padding: '4px',
                color: isUserFavorite ? '#ffa726' : 'var(--secondary-color)',
                '&:hover': {
                  backgroundColor: 'transparent',
                  color: '#ffa726',
                },
              }}
            >
              {isUserFavorite ? (
                <Star sx={{ fontSize: '18px' }} />
              ) : (
                <StarBorder sx={{ fontSize: '18px' }} />
              )}
            </IconButton>
          )}
        </div>
      </li>
    );
  },
);
